<div class="container">
    <div class="top-header">
        <h2>Invite Teachers to Onboard via Email</h2>
        <p>Send invitations to teachers and manage their onboarding status</p>
    </div>

    <div class="invite-card">
        <h2 class="invite-title">
            <span class="invite-icon"><i class="bi bi-people"></i></span>
            Invite Teachers
        </h2>

        <div class="invite-input-group">
			  <form [formGroup]="teacherInviteForm">
            <input type="email" placeholder="Enter teacher's email address"
			formControlName="teacher_emails" id="teacherEmail"class="invite-input" />

            <button class="btn-add ms-4" (click)="addEmail()"
			[disabled]="teacherInviteForm.invalid">Add</button>
			</form>
        </div>

		  <div class="emails-list" *ngIf="emailsToInvite.length > 0">
    <span class="email-chip" *ngFor="let email of emailsToInvite; let i=index">
      {{ email }}
      <button class="remove-btn" (click)="emailsToInvite.splice(i,1)">
	<img src="assets/images/close_button.svg" alt="close-icon">
	</button>
    </span>
  </div>

        <button class="btn-add w-100" (click)="inviteTeacher()"
		[disabled]="emailsToInvite.length === 0">
		 <ng-container *ngIf="isInviting; else noInviting">
					<span class="spinner-border spinner-border-sm"></span> Sending Invitation...
            </ng-container>
			<ng-template #noInviting>
			<i class="bi bi-send me-3"></i> Send  {{emailsToInvite.length || ''}}  Invitations
			</ng-template>
        </button>
    </div>
    <!-- table -->
    <div class="invited-card">
        <h2 class="invited-title">
            Invited Teachers ({{ totalTeachersCount }})
        </h2>

        <table class="invited-table" *ngIf="inviteTeacherOnBoard.length > 0; else noData">
            <thead>
                <tr>
                    <th>Email ID</th>
                    <th>Invited On</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let inviteTeacher of inviteTeacherOnBoard">
                    <td>{{ inviteTeacher.email }}</td>
                    <td>{{ inviteTeacher.created_at  | istDate}}</td>
                    <td>
                        <span class="status" [ngClass]="{
                   onboarded: inviteTeacher.is_used, 
				  pending: !inviteTeacher.is_used}">
              {{ inviteTeacher.is_used ? 'Onboarded' : 'Pending' }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>

        <ng-template #noData>
            <p class="no-data">No invited teachers found.</p>
        </ng-template>
    </div>


</div>